<app-dialog-title>
  @if (isDGL) {
  <p>{{ "approve" | transloco }} {{ taxReturnAlias }}</p>
  } @if (!isDGL) {
  <p>{{ "lodge" | transloco }} {{ taxReturnAlias }}</p>
  }
</app-dialog-title>
@if (displayFlag == 'submissionForm' ) {
<div>
  <mat-dialog-content class="content">
    @if (isDGL) {
    <div>
      <p *transloco="let t">
        {{ "are-you-sure-you-want-to" | transloco }}
        {{ employerApproved && taxpayerApproved ? t("lodge") : t("approve") }}
        {{ "this" | transloco }} {{ taxReturnAlias }} {{ "for" | transloco }}
        <strong>{{ taxReturn.firstName }} {{ taxReturn.lastName }}</strong
        >.
      </p>
      <div
        class="ui checkbox dgl-approval-checkbox"
        [ngClass]="{ checked: employerApproved }"
      >
        <input
          type="checkbox"
          [(ngModel)]="employerApproved"
          id="employerApproved_checkbox"
        />
        <label for="employerApproved_checkbox">{{
          "employer-approved" | transloco
        }}</label>
      </div>
      <div
        class="ui checkbox dgl-approval-checkbox"
        [ngClass]="{ checked: taxpayerApproved }"
      >
        <input
          type="checkbox"
          [(ngModel)]="taxpayerApproved"
          id="taxpayerApproved_checkbox"
        />
        <label for="taxpayerApproved_checkbox">{{
          "taxpayer-alias-approved" | transloco
        }}</label>
      </div>
    </div>
    } @if (!isDGL) {
    <p>
      {{ 'are-you-sure-you-want-to-lodge-this-tax-return-alias-for' | transloco: {taxReturnAlias} }}
      <strong>{{ taxReturn.firstName }} {{ taxReturn.lastName }}</strong
      >.
    </p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end" *transloco="let t">
    <button
      class="go-back cancel btn-link"
      (click)="onClose()"
      [disabled]="isLoading"
    >
      {{ "cancel" | transloco }}
    </button>
    @if (!isLoading) {
    <button
      [disabled]="!employerApproved && !taxpayerApproved"
      (click)="confirmApproval()"
      class="ui primary button"
    >
      @if (isDGL) {
      <span>
        {{ employerApproved && taxpayerApproved ? t("lodge") : t("approve")
        }}{{ taxReturnAlias }}
      </span>
      } @if (!isDGL) {
      <span>{{ "lodge" | transloco }} {{ taxReturnAlias }}</span>
      }
    </button>
    } @if (isLoading) {
    <button class="ui primary loading button">
      @if (isDGL) {
      <span>
        {{ employerApproved && taxpayerApproved ? t("lodge") : t("approve")
        }}{{ taxReturnAlias }}
      </span>
      } @if (!isDGL) {
      <span>{{ "lodge" | transloco }} {{ taxReturnAlias }}</span>
      }
    </button>
    }
  </mat-dialog-actions>
</div>
} @if (displayFlag == 'successMessage' ) {
<div>
  <mat-dialog-content class="content modal-success">
    <div class="icon green-success modal-icon__main"></div>
    <p>{{ submitSuccessMsg }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="completed.emit(); onClose(true)" class="ui primary button">
      {{ "ok" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
} @if (displayFlag == 'errorMessage' &&
configStateService.featureFlags.checkUnsignedDocs) {
<div>
  <mat-dialog-content class="content modal-fail">
    <p class="missing-doc">{{ "missing-signed-document-s" | transloco }}</p>
    @for (f of submitFailureMsg; track f) {
    <div class="display-error-msg">
      <i class="close icon error"></i> {{ f }}
    </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onClose()" class="ui primary button">
      {{ "ok" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
}

<!-- TRANSLOCO TODO -->
@if (displayFlag == 'errorMessage' &&
!configStateService.featureFlags.checkUnsignedDocs) {
<div>
  <mat-dialog-content class="content modal-fail">
    <p class="missing-doc">{{ "unable-to-complete-action" | transloco }}</p>
    <div class="display-error-msg">
      <i class="close icon error"></i> {{ submitFailureMsg.message }}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onClose()" class="ui primary button">
      {{ "ok" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
}
<!-- END OF TRANSLOCO TODO-->
